// src/locales/en/auth.js
export const auth = {
    login: "පිවිසෙන්න",
    signup: "ලියාපදිංචි වන්න",
    logout: "ඉවත්වන්න",
    email: "ඊමේල් ලිපිනය",
    password: "මුරපදය",
    confirmPassword: "මුරපදය තහවුරු කරන්න",
    name: "සම්පූර්ණ නම",
    rememberMe: "මතක තබා ගන්න",
    forgotPassword: "මුරපදය අමතකද?",
    dontHaveAccount: "ගිණුමක් නොමැතිද?",
    alreadyHaveAccount: "දැනටමත් ගිණුමක් තිබේද?",
    signIn: "පිවිසෙන්න",
    createAccount: "ගිණුම සාදන්න",
    continueWithGoogle: "Google සමඟ ඉදිරියට යන්න",
    welcomeBack: "ආයුබෝවන්",
    signInToDashboard: "ඔබේ ඊ-වාණිජ උපකරණ පුවරුවට පිවිසෙන්න",
    startManaging: "අදම ඔබේ ඊ-වාණිජ ව්‍යාපාරය කළමනාකරණය කිරීම ආරම්භ කරන්න",
    invalidCredentials: "වලංගු නොවන ඊමේල් හෝ මුරපදය",
    accountCreated: "ගිණුම සාර්ථකව සාදන ලදී!",
    loginToConnect: "ඉදිරියට යාමට කරුණාකර පිවිසෙන්න.",
    passwordMinLength: "මුරපදය අවම වශයෙන් අක්ෂර 6ක් විය යුතුය",
    passwordsDoNotMatch: "මුරපද නොගැලපේ",
    validEmailRequired: "කරුණාකර වලංගු ඊමේල් ලිපිනයක් ඇතුළත් කරන්න",
    nameRequired: "නම අවශ්‍යය",
    loginSuccessful: "සාර්ථක පිවිසුම",
    signupSuccessful: "සාර්ථක ලියාපදිංචිය",
}